export const actions = {
  user: {
    code: 'user',
    name: 'Tài khoản',
    actions: {
      create_user: { code: 'user:create', name: 'Tạo tài khoản mới' },
      update_user: { code: 'user:update', name: 'Sửa thông tin tài khoản' },
      get_user: { code: 'user:get', name: 'Xem thông tin tài khoản' },
      get_users: { code: 'users:get', name: 'Xem danh sách tài khoản' },
      delete_user: { code: 'user:delete', name: 'Xóa tài khoản' },
      update_profile: { code: 'profile:update', name: 'Cập nhật profile' },
    }
  },

  role: {
    code: 'role',
    name: 'Vai trò',
    actions: {
      create_role: { code: 'role:create', name: 'Tạo vai trò mới' },
      update_role: { code: 'role:update', name: 'Sửa thông tin vai trò' },
      get_role: { code: 'role:get', name: 'Xem chi tiết vai trò' },
      get_roles: { code: 'roles:get', name: 'Xem danh sách vai trò' },
      delete_role: { code: 'role:delete', name: 'Xóa vai trò' },
    }
  },

  link: {
    code: 'link',
    name: 'Link',
    actions: {
      create_link: { code: 'link:create', name: 'Tạo link mới' },
      update_link: { code: 'link:update', name: 'Chỉnh sửa link' },
      update_granted_link: { code: 'link:updateGranted', name: '--- Chỉnh sửa link được cấp quyền' },
      get_links: { code: 'links:get', name: 'Xem danh sách links' },
      get_granted_links: { code: 'links:getGranted', name: '--- Xem danh sách links được cấp quyền' },
      link_permission_update: { code: 'link-permission:update', name: 'Cấp quyền chỉnh sửa link (ADMIN)' },
      delete_link: { code: 'link:delete', name: 'Xóa link' },
    }
  },

  log: {
    code: 'log',
    name: 'Nhật ký hệ thống',
    actions: {
      get_logs: { code: 'logs:get', name: 'Xem nhật ký hệ thống' },
      delete_log: { code: 'log:delete', name: 'Xóa nhật ký hệ thống' },
    }
  },

  analytics: {
    code: 'analytics',
    name: 'Thống kê',
    actions: {
      get_analytics: { code: 'analytics:get', name: 'Xem thống kê' },
    }
  },

  whitelistIp: {
    code: 'whitelist-ip',
    name: 'Whitelist IP',
    actions: {
      get_whitelist_ips: { code: 'whitelist-ips:get', name: 'Xem danh sách whitelist ips' },
      create_whitelist_ip: { code: 'whitelist-ip:create', name: "Thêm whitelist IP" },
      delete_whitelist_ip: { code: 'whitelist-ip:delete', name: "Xóa whitelist IP" }
    }
  }
};